module.exports = __webpack_public_path__ + "static/ae5-dda6ac236b365049dcb639eab0e18776.svg";